import { DireccionDTO } from "./direccion";
import { Usuario } from "./usuario";


/**Bitacora para programar las entregas de RAD */
export interface BitacoraRAD {
    IdRegistro?: number;

    FechaSolicitud?: Date;
    FechaProgramada?: Date;

    TipoRecoleccion?: HorarioRad;
    IdSucursal?: number;
    IdSucursalRecoleccion?:number;
    IdDireccionCliente?: number;
    Telefono?: string;
    HorarioSugeridoDesde?: number;
    HorarioSugeridoHasta?: number;
    UsuarioCreador?: string;

    /**Paquetes de la bitacora */
    Paquetes: BitacoraRADPaquete[];

    /**Status de RAD */
    Status?: StatusBitacoraRad;

    CanalEntrada: CanalEntrada;

    QuienSolicita: QuienSolicita;

    /**cambio de status */
    HistorialStatus: BitacoraRADCambioStatus[];

    Observaciones: string;

    NombreQuienSolicita: string;
}

export interface BitacoraRADPaquete {
    IdRegistro: number;

    IdBitacoraRAD: number;
    BitacoraRAD: BitacoraRAD;

    IdContenidoPaquete: number;
    IdDescripcionPaquete: number;

    Cantidad: number;

    /**Peso en KG. Solo aplica para los paquetes */
    Peso: number;
    /**Largo en CM. Sólo aplica para los paquetes */
    Largo: number;

    /**Alto en CM. Sólo aplica para los paquetes */
    Alto: number;

    /**Ancho en CM. Sólo aplica para los paquetes */
    Ancho: number;
}

export interface BitacoraRADCambioStatus {
    IdRegistro: number;
    IdBitacoraRad: number;
    Observaciones: string;
}

export enum StatusBitacoraRad {
    Pendiente,
    Listo,
    Cancelada
}

export enum HorarioRad {
    /**Una RAD programada para el mismo día, solo apkica si se hace de 8:00 a 14:00 */
    MismoDia,

    /**Una RAD programada para una fecha futura */
    Programado
}

export enum CanalEntrada {
    Teléfono,
    Whatsapp,
    Correo,
    Instagram,
    Solicitud_interna,
}

export enum QuienSolicita
    {
        Cliente_origen,
        Gerente_de_sucursal_origen,
        Cliente_destino,
        Gerente_de_sucursal_destino
    }

export interface BitacoraRADDto extends BitacoraRAD {
    NombreSucursal: string;
    NombreCliente: string;
    DireccionDto: DireccionDTO;
    NombreSucursalRecoleccion: string;
    CantPaquetes: number;
    Paquetes: BitacoraRADPaqueteDto[];
    Usuario: Usuario;
    DescripcionPaquetesTexto: string;
}

export interface BitacoraRADPaqueteDto extends BitacoraRADPaquete {
    NombreContenidoPaquete: string;
    NombreDescripcionPaquete: string;
}

/**Filtro para la consulta de bitacora RAD */
export interface BitacoraRADFiltro {
    FechaMin?: Date | string | null;
    FechaMax?: Date | string | null;
    Status?: StatusBitacoraRad | null;
    IdSucursal?: number | null;
    IdSucursalRecoleccion?: number | null;
    Limite?: number | null;
    UsuarioCreador?: string | null;
}

/**Un cambio de status de la bitácora de RAD */
export interface BitacoraRADCambioStatus {
    IdRegistro: number;

    Fecha: Date | string;
    Status: StatusBitacoraRad;

    IdUsuario: number;

    Observaciones: string;

    IdBitacoraRad: number;

    Usuario: Usuario;
}

export interface BitacoraRADStatusDto extends BitacoraRADCambioStatus {
    NombreUsuario: string;
}


export enum CodigoRegimenFiscal {
"601 - General de Ley Personas Morales",
"603 - Personas Morales con Fines no Lucrativos",
"605 - Sueldos y Salarios e Ingresos Asimilados a Salarios",
"606 - Arrendamiento",
"607 - Régimen de Enajenación o Adquisición de Bienes",
"608 - Demás ingresos",
"609 - Consolidación",
"610 - Residentes en el Extranjero sin Establecimiento Permanente en México",
"611 - Ingresos por Dividendos (socios y accionistas)",
"612 - Personas Físicas con Actividades Empresariales y Profesionales",
"614 - Ingresos por intereses",
"615 - Régimen de los ingresos por obtención de premios",
"616 - Sin obligaciones fiscales",
"620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
"621 - Incorporación Fiscal",
"622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
"623 - Opcional para Grupos de Sociedades",
"624 - Coordinados",
"625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
"626 - Régimen Simplificado de Confianza",
"628 - Hidrocarburos",
"629 - De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales",
"630 - Enajenación de acciones en bolsa de valores"
}


// WEBPACK FOOTER //
// ./app/models/bitacorarad.ts